import { breakpoints, colors } from 'style'
import styled from 'styled-components'

export const TopbarContainer = styled.div`
  width: 100%;
  background: ${colors.white};
  .navbar {
    height: 90px;
    border-bottom: solid 1px #000;
    .topbar-wrapper {
      .navbar-brand {
        margin-left: 16px;
        margin-top: 13px;
        img {
          width: 180px;
        }
      }
      .navbar-toggler {
        border-color: transparent;
        color: ${colors.black} !important;
      }
    }
    .navbar-collapse {
      .navbar-nav {
        a {
          color: ${colors.black};
          font-size: 14px;
          line-height: 23px;
          margin-right: 26px;
          text-transform: uppercase;
          &:hover {
            text-decoration: underline;
          }
        }
        .dropdown {
          .dropdown-toggle {
            text-transform: uppercase;
          }
        }
      }
    }

    .spinner-wrapper {
      margin-top: -5px;
    }
  }
  .topbar-bottom {
    height: 56px;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9;
    a {
      color: ${colors.black};
      font-size: 18px;
      margin: 0 16px;
    }
    .active {
      text-decoration: underline;
    }
  }
  @media (max-width: 767px) {
    min-height: 50px;
    padding: 0;
    z-index: 1000;
    .navbar {
      height: 52px;
      padding: 0;
      .topbar-wrapper {
        min-height: 50px;
        display: flex;
        align-items: center;
        width: 100%;
        .navbar-brand {
          flex: 1;
          text-align: center;
          margin-top: 0;
          margin-left: 0;
          img {
            height: 29px;
          }
        }
      }

      .navbar-collapse {
        background: white;
        .navbar-nav {
          padding: 15px;
          a {
            margin-left: 0px;
            align-self: flex-start;
            margin-bottom: 5px;
          }
        }
      }
    }
    .topbar-bottom {
      height: 40px;
    }
  }
  @media (max-width: ${breakpoints.xs}px) {
    .topbar-bottom {
      a {
        font-size: 15px;
        margin: 0 8px;
      }
    }
  }

  @media (min-width: 769px) {
    .topbar-top {
      margin-top: 16px;
    }
  }

  .topbar-top {
    margin-top: 16px;
    z-index: 99;
  }
`
